module.exports = __webpack_public_path__ + "img/payroll-text-en.68c6c7b8.png";